export default "__VITE_ASSET__fc0a9cbe__"